import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
  RepeatableMultipleInputStackFilds,
} from "@/components";
import React, { useMemo } from "react";

const AboutUsThirdTabCMSFormFields = ({
  activeTab,
  selectedTab,
  isFetching,
  formData,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  onChangeImage,
  addMultiValueRepeaterChange,
  removeMultiValueRepeaterChange,
  updateMultiValueRepeaterChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="mission-statement-heading"
            fieldName="mission-statement-heading"
            placeholderText="Heading"
            inputValue={formData?.["mission-statement-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Inner Tabs */}
          <RepeatableMultipleInputStackFilds
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Inner Tabs"
            fieldId="mission-statement-inner-tabs"
            fieldKey="mission-statement-inner-tabs"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            addMultiValueRepeaterChange={addMultiValueRepeaterChange}
            removeMultiValueRepeaterChange={removeMultiValueRepeaterChange}
            updateMultiValueRepeaterChange={updateMultiValueRepeaterChange}
            translateField={true}
            extraContainerClasses="mt-5"
            filedStructure={[
              "TEXT",
              "TEXT",
              "TEXT",
              "TEXT_EDITOR",
              "TEXT",
              "TEXT",
              "IMAGE",
            ]}
            dataStructure={{
              tabName: "",
              tabValue: "",
              tabContentHeading: "",
              tabContentDescription: "",
              tabPersonName: "",
              tabPersonDesignation: "",
              tabContentImageId: "",
            }}
            placeholderTexts={[
              "Tab Name",
              "Tab Value",
              "Tab Content Heading",
              "Tab Content Description",
              "Tab Person Name",
              "Tab Person Designation",
              "",
            ]}
            hideStatus={[
              true,
              isHideInOtherLanguages,
              true,
              true,
              true,
              true,
              isHideInOtherLanguages,
            ]}
            colorGrade={colorGrade}
          />
        </>
      )}

      {selectedTab === "section-2" && (
        <>
          {/* Message Name */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Name"
            fieldId="mission-statement-message-name"
            fieldName="mission-statement-message-name"
            placeholderText="Name"
            inputValue={formData?.["mission-statement-message-name"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Designation */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Designation"
            fieldId="mission-statement-message-designation"
            fieldName="mission-statement-message-designation"
            placeholderText="Designation"
            inputValue={
              formData?.["mission-statement-message-designation"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Message */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Message"
            fieldId="mission-statement-message-content"
            fieldName="mission-statement-message-content"
            placeholderText="Description"
            inputValue={formData?.["mission-statement-message-content"] || ""}
            onChangeTextEditorFiled={handleTextEditorInputChange}
            extraContainerClasses="mt-5"
            translateField={true}
          />

          {/* About Company Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Image"
              fieldId="mission-statement-message-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? onChangeImage("mission-statement-message-image", id)
                  : onChangeImage("mission-statement-message-image", "")
              }
              selectedFileId={
                formData?.["mission-statement-message-image"] || ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              extraContainerClasses="mt-5"
            />
          )}
        </>
      )}
    </>
  );
};

export default AboutUsThirdTabCMSFormFields;
